export default {
    /*
    * 简单粗暴数组去重
    * @params array {Array}
    * @key 键
    * @return  {Array}
    * */
    arrayDelRepeat: function (array, key) {
        var temp = [];
        var keylist = [];
        try {
            for (let i = 0; i < array.length; i++) {
                let item = array[i];
                if (key) {
                    if (keylist.indexOf(item[key]) === -1) {
                        temp.push(item);
                        keylist.push(item[key])
                    }

                } else {
                    if (keylist.indexOf(item) === -1) {
                        temp.push(item);
                        keylist.push(item)
                    }
                }
            }

        } catch (e) {
            console.log("数组去重错误")
        }

        return temp;

    },
    //判断是不是微信
    is_weixin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true;
        } else {
            return false;
        }
    },
    timestampToTime: function (timestamp) {
        var date = new Date(parseInt(timestamp));

        var Y = date.getFullYear() + '-';
        var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours();
        if (h < 10) {
            h = '0' + h;
        }
        h = h + ':';

        var m = date.getMinutes();
        if (m < 10) {
            m = '0' + m;
        }
        var time = h.toString() + m ? m : '00';

        return {
            day: Y + M + D + h + m,
            time: time,
            m: M + D + h + m
        }
    },
    /*
    * @params ｛data ｝ 分享数据
    * @params {res} 分享配置
    * @params {baoliao} 是否是爆料，爆料分享朋友圈的标题是简介
    * */
    setWeiXinShare(data, res, baoliao) {
        try {
            try {
                if (data.title && data.title.length > 50) {
                    data.title = data.title.slice(0, 50)
                }
                data.desc = data.desc.replace(/<.*?>/g, '');
                if (data.desc && data.desc.length > 50) {
                    data.desc = data.desc.slice(0, 50)
                }
            } catch (e) {
                console.log("处理标题简介失败", e)
            }


            /*
            *
            * {
  debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  appId: '', // 必填，公众号的唯一标识
  timestamp: , // 必填，生成签名的时间戳
  nonceStr: '', // 必填，生成签名的随机串
  signature: '',// 必填，签名
  jsApiList: [] // 必填，需要使用的JS接口列表
}
            * */
            res.jsApiList = [
                'checkJsApi',
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ];
            wx.config(res);
            wx.ready(() => {
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                wx.updateAppMessageShareData({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        console.log('设置成功')
                    }
                });
                wx.updateTimelineShareData({
                    title: baoliao ? data.desc : data.title, // 分享标题
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        console.log('设置成功')
                    }
                });
                wx.onMenuShareAppMessage({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('设置onMenuShareAppMessage成功')
                    }
                });

                wx.onMenuShareTimeline({
                    title: baoliao ? data.desc : data.title, // 分享标题
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('onMenuShareTimeline')
                    }
                });
                wx.checkJsApi({
                    jsApiList: [
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline',
                        'updateAppMessageShareData',
                        'updateTimelineShareData'
                    ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function (res) {
                        console.log('checkJsApi:', res)

                    }
                });

            });
        } catch (e) {
            console.log("设置分享失败", e)
        }
    },
    /*
 * @params ｛data ｝ 分享数据
 * @params {res} 分享配置
 * @params {baoliao} 是否是爆料，爆料分享朋友圈的标题是简介
 * */
    setWeiXinShareTest(data, res, baoliao) {
        try {
            try {
                if (data.title && data.title.length > 50) {
                    data.title = data.title.slice(0, 50)
                }
                data.desc = data.desc.replace(/<.*?>/g, '');
                if (data.desc && data.desc.length > 50) {
                    data.desc = data.desc.slice(0, 50)
                }
            } catch (e) {
                alert("处理标题简介失败")
            }


            /*
            *
            * {
  debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
  appId: '', // 必填，公众号的唯一标识
  timestamp: , // 必填，生成签名的时间戳
  nonceStr: '', // 必填，生成签名的随机串
  signature: '',// 必填，签名
  jsApiList: [] // 必填，需要使用的JS接口列表
}
            * */
            res.jsApiList = [
                'checkJsApi',
                'onMenuShareAppMessage',
                'onMenuShareTimeline',
                'updateAppMessageShareData',
                'updateTimelineShareData'
            ];
            res.debug = true;
            wx.error(function (res) {
                alert(JSON.stringify(res))
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            });

            console.log(data)
            wx.config(res);
            wx.ready(() => {
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。


                wx.updateAppMessageShareData({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        // 设置成功
                        console.log('设置updateAppMessageShareData成功')
                    }
                });
                wx.updateTimelineShareData({
                    title: baoliao ? data.desc : data.title, // 分享标题
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        console.log('设置updateTimelineShareData成功')
                    }
                });

                wx.onMenuShareAppMessage({
                    title: data.title, // 分享标题
                    desc: data.desc, // 分享描述
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    type: 'link', // 分享类型,music、video或link，不填默认为link
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('设置onMenuShareAppMessage成功')
                    }
                });

                wx.onMenuShareTimeline({
                    title: baoliao ? data.desc : data.title, // 分享标题
                    link: data.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: data.imgUrl, // 分享图标
                    success: function () {
                        // 用户点击了分享后执行的回调函数
                        console.log('onMenuShareTimeline')
                    }
                });

                wx.checkJsApi({
                    jsApiList: [
                        'onMenuShareAppMessage',
                        'onMenuShareTimeline',
                        'updateAppMessageShareData',
                        'updateTimelineShareData'
                    ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
                    success: function (res) {
                        console.log('checkJsApi:', res)

                    }
                });

            });


        } catch (e) {
            alert("设置分享失败")
        }
    },

    //TextAre换行符
    TextAreaText2Html: function TextAreaText2Html(str) {
        if (!str) {
            return "";
        }

        var reg = /\n/gim;
        var reg1 = /\r/gim;
        str = str.replace(reg, "<br />");
        str = str.replace(reg1, "<br />");
        return str;
    },
    openPage(data,_this) {
        if (data.art_link) {
            try {
                var info = JSON.parse(data.art_link);
                console.log(info)
                switch (info.module) {
                    case 'zixun':
                        switch (info.page) {
                            case 'art_info':
                                _this.$router.push({name:"NewsContent",params: { id:info.id}});
                                setTimeout(function(){
                                    location.reload()
                                },200)
                                break;

                            case 'zl_lists':
                                //专栏列表
                                _this.$router.push({name:"SpecialList",params: { id:info.id}});

                                break;
                            case 'zt_lists':
                                //专题列表
                                _this.$router.push({name:"ZhuanTiList",params: { id:info.id}});

                                break;


                        }

                        break;

                    case 'video':
                        switch (info.page) {
                            case 'viedo_info':

                                location.href = 'http://img2.yitoutiao.net/app/share.html?id='+info.id;
                                break;


                        }

                        break;



                    case 'shenniaoai':
                        //AI视频

                        break;





                    case 'ask':
                        // console.log(JSON.stringify(info))


                        break;

                    case 'other':
                        //其他，url
                        if (info.page ==="out_url" &&  info.id) {
                            location.href = info.id
                        }

                        break;

                    case 'shequ':
                        if (info.id) {

                        }

                        break;
                    case 'customlist':
                        _this.$router.push({name:"custom_list",params: { id:info.id}});


                        break;

                }
            } catch (e) {
                console.log(e)
            }
        }
    },

}
